"use strict";
/**
 * Export report utility
 * Fetches report in specified format and triggers download
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.exportReport = exportReport;
var getMimeType = function (format) {
    switch (format) {
        case "csv":
            return "text/csv";
        case "xlsx":
            return "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        case "pdf":
            return "application/pdf";
        default:
            return "application/octet-stream";
    }
};
function exportReport(options) {
    return __awaiter(this, void 0, void 0, function () {
        var endpoint, filename, format, _a, params, authData, token, baseUrl, url, response, errorData, blob, downloadUrl, link;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    endpoint = options.endpoint, filename = options.filename, format = options.format, _a = options.params, params = _a === void 0 ? {} : _a;
                    authData = localStorage.getItem("sky_auth");
                    token = authData ? JSON.parse(authData).token : null;
                    if (!token) {
                        throw new Error("Not authenticated");
                    }
                    baseUrl = process.env.API_URL || window.location.origin;
                    url = new URL("".concat(baseUrl).concat(endpoint), window.location.origin);
                    url.searchParams.set("format", format);
                    Object.entries(params).forEach(function (_a) {
                        var key = _a[0], value = _a[1];
                        if (value !== undefined && value !== "") {
                            url.searchParams.set(key, String(value));
                        }
                    });
                    return [4 /*yield*/, fetch(url.toString(), {
                            method: "GET",
                            headers: {
                                Authorization: "Bearer ".concat(token),
                            },
                        })];
                case 1:
                    response = _b.sent();
                    if (!!response.ok) return [3 /*break*/, 3];
                    return [4 /*yield*/, response.json().catch(function () { return ({}); })];
                case 2:
                    errorData = _b.sent();
                    throw new Error(errorData.message || "Failed to export report");
                case 3: return [4 /*yield*/, response.blob()];
                case 4:
                    blob = _b.sent();
                    downloadUrl = window.URL.createObjectURL(new Blob([blob], { type: getMimeType(format) }));
                    link = document.createElement("a");
                    link.href = downloadUrl;
                    link.setAttribute("download", "".concat(filename, ".").concat(format));
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    window.URL.revokeObjectURL(downloadUrl);
                    return [2 /*return*/];
            }
        });
    });
}
